import { IconComponent } from './types';

const PuzzleIcon: IconComponent = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.21429 5.71429V6.21429H9.71429H10.5714C11.0839 6.21429 11.5 6.63043 11.5 7.14286C11.5 7.65529 11.0839 8.07143 10.5714 8.07143H9.71429H9.21429V8.57143V10.8571C9.21429 11.2096 8.92386 11.5 8.57143 11.5H6.9V11.1429C6.9 10.0153 5.98471 9.1 4.85714 9.1C3.72957 9.1 2.81429 10.0153 2.81429 11.1429V11.5H1.14286C0.790428 11.5 0.5 11.2096 0.5 10.8571V9.18571H0.857143C1.98471 9.18571 2.9 8.27043 2.9 7.14286C2.9 6.01529 1.98471 5.1 0.857143 5.1H0.505714V3.42857C0.505714 3.07287 0.793685 2.78571 1.14286 2.78571H3.42857H3.92857V2.28571V1.42857C3.92857 0.916142 4.34471 0.5 4.85714 0.5C5.36957 0.5 5.78571 0.916142 5.78571 1.42857V2.28571V2.78571H6.28571H8.57143C8.92386 2.78571 9.21429 3.07614 9.21429 3.42857V5.71429Z"
      stroke="currentColor"
    />
  </svg>
);

export default PuzzleIcon;
